<template>
  <div class="price-box">
    <div v-if="part.price">
      <p class="spare-name">{{ part.name }}</p>
      <p class="spare-sku">{{ part.SKU }}</p>
      <div v-if="part.avc" class="avc-status">
        <span :class="`dot-${part.avc_status}`"></span>
        <span class="avc-info">
          <span v-if="part.avc_status == 1">{{ $t('message.available') }}</span>
          <span v-if="part.avc_status == 2"
            >{{ $t('message.availableFrom') }} {{ part.avc_ETA }}</span
          >
          <span v-if="part.avc_status == 0">{{
            $t('message.notAvailable')
          }}</span>
        </span>
        <br />
      </div>
      <p class="spare-price">
        <span :class="{ 'spare-price-old': part.priceSale }"
          >{{ part.price }}&nbsp;€</span
        >
        <span class="spare-price-new" v-if="part.priceSale">
          <br />
          {{ part.priceSale }}€
        </span>
      </p>
    </div>
    <div v-if="part.price" class="input-group">
      <input type="text" class="form-control input-qty" v-model="part.qty" />
      <div class="input-group-btn">
        <button
          @click="buy(part)"
          class="dl_add_to_cart btn"
          :class="`btn-action-${brand}`"
          :disabled="part.qty <= 0"
          :data-sku="part.SKU"
          :data-brand="brand"
        >
          <img
            class="buy-icon"
            src="https://teilecdn.com/assets/icons/add.svg"
          />
          <div v-if="avcNative == false && avcLive == false">
            {{ $t('message.checkAvailability') }}
          </div>
          <div v-else>
            {{ $t('message.buy') }}
          </div>
        </button>
      </div>
    </div>
    <div v-else>
      <button :class="`btn btn-action-${brand}`" style="width: 100%" disabled>
        <img class="buy-icon" src="https://teilecdn.com/assets/icons/add.svg" />
        {{ $t('message.notAvailable') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PriceBox',
  computed: {
    brand: {
      get() {
        return this.$store.state.brand;
      },
    },
    avcNative: {
      get() {
        return this.$store.state.avcNative;
      },
    },
    avcLive: {
      get() {
        return this.$store.state.avcLive;
      },
    },
    part: {
      get() {
        return this.$store.state.selectedPart;
      },
    },
    qty: {
      get() {
        return this.$store.state.selectedPart.qty;
      },
      set(value) {
        this.$store.commit('setQty', value);
        console.log('New qty', value);
      },
    },
  },
  methods: {
    ...mapActions(['buy']),
  },
};
</script>